import React from 'react';
const PrivacyPage = () => {
  return <div className="container mx-auto px-4 py-12" data-id="element-297">
      <h1 className="text-3xl font-bold mb-8 text-[#1A2B4C]" data-id="element-298">
        Privacy & Cookie Policy
      </h1>
      <div className="bg-white rounded-lg shadow-sm p-8" data-id="element-299">
        <p className="mb-6" data-id="element-300">
          Your privacy is a top priority for us at Elevatefix. This policy
          explains what information we collect, how we use it, and how we keep
          it safe.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-301">1. Who We Are</h2>
        <p className="mb-6" data-id="element-302">
          Elevatefix is a UK-based company providing professional appliance
          repair and service plans.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-303">
          2. The Information We Collect
        </h2>
        <p className="mb-6" data-id="element-304">
          When you interact with our website or services, we may collect various
          types of data from you, including:
          <br data-id="element-305" />
          <br data-id="element-306" />
          • Your name, address, email, and phone number
          <br data-id="element-307" />
          • Payment details for processing your service plans
          <br data-id="element-308" />
          • Information about the appliances you have and any past repair
          history with us
          <br data-id="element-309" />• Data collected through cookies, which helps us understand how
          you use our site
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-310">
          3. How We Use Your Information
        </h2>
        <p className="mb-6" data-id="element-311">
          We use the data we collect to:
          <br data-id="element-312" />
          <br data-id="element-313" />
          • Manage your service plan and provide the services you've purchased
          <br data-id="element-314" />
          • Schedule repairs and offer customer support
          <br data-id="element-315" />
          • Send you important updates about our services or your account
          <br data-id="element-316" />
          • Meet our legal obligations
          <br data-id="element-317" />• Improve our website and the services we offer
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-318">
          4. Sharing Your Data
        </h2>
        <p className="mb-6" data-id="element-319">
          We will never sell your personal information. We may share your data
          with trusted third parties who help us operate our business, such as
          payment processors and website hosting providers. We may also share
          your data if we are legally required to do so by law enforcement or a
          regulatory body.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-320">5. Cookies</h2>
        <p className="mb-6" data-id="element-321">
          Our website uses cookies to improve your browsing experience and
          analyse how our site is used. You can manage your cookie preferences
          at any time through your browser settings.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-322">
          6. Your Privacy Rights
        </h2>
        <p className="mb-6" data-id="element-323">
          You have the right to:
          <br data-id="element-324" />
          <br data-id="element-325" />
          • Request a copy of the personal data we hold about you
          <br data-id="element-326" />
          • Ask us to correct or delete your information
          <br data-id="element-327" />
          • Withdraw your consent for any marketing communications
          <br data-id="element-328" />
          <br data-id="element-329" />
          To exercise these rights, please contact our customer service team at
          dronakoirala6@gmail.com or call us on 0800 055 4969.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-330">
          7. Data Security
        </h2>
        <p className="mb-6" data-id="element-331">
          We use robust security measures to protect your personal information.
          However, please be aware that no data transmission over the internet
          is ever 100% secure.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-332">8. Contact Us</h2>
        <p className="mb-4" data-id="element-333">
          If you have any questions about this policy or how we handle your
          data, please get in touch with our customer relations team at:
          <br data-id="element-334" />
          <br data-id="element-335" />
          Email: dronakoirala6@gmail.com
          <br data-id="element-336" />
          Phone: 0800 055 4969
        </p>
      </div>
    </div>;
};
export default PrivacyPage;